import styled, { css } from 'styled-components';

import { breakpoints, theme } from '@notino/react-styleguide';

import { CommonContainer, CommonMarginWrapper } from '../../styled';

export const Container = styled(CommonContainer)<{ newDesign: boolean }>`
  ${({ newDesign }) =>
    newDesign &&
    css`
      @media (min-width: ${breakpoints.lg}) {
        padding-right: 2rem;
      }
    `}
`;

export const MarginWrapper = styled(CommonMarginWrapper)``;

export const Description = styled.div<{ newPdDesignEnabled: boolean }>`
  display: block;

  p {
    margin: 0 0 1.3em;

    &:last-child {
      margin-bottom: 0;
    }
  }

  ${({ newPdDesignEnabled }) =>
    newPdDesignEnabled
      ? css`
          width: 100%;
          color: ${theme.color.text.secondary};
          ${theme.typography.bodyRegular};

          @media (min-width: ${breakpoints.lg}) {
            ${theme.typography.bodyLarge}
          }
        `
      : css`
          font-size: 0.9rem;
          margin-top: 1rem;

          p {
            line-height: 1.5;
          }

          @media (min-width: ${breakpoints.md}) {
            display: block;
            column-count: 2;
            column-gap: 30px;
            column-rule: 0 solid transparent;
          }
        `}
`;
